var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8InstagramVerificationBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#38c20a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.734,8.7l.96-1.876-1.77-1.144-.106-2.1-2.1-.105L10.569,1.7l-1.875.961L6.818,1.7,5.675,3.468l-2.1.106-.106,2.1L1.7,6.824,2.657,8.7,1.7,10.574l1.77,1.144.106,2.1,2.1.105L6.823,15.7,8.7,14.735l1.876.96,1.143-1.77,2.1-.106.106-2.1L15.7,10.57ZM7.867,10.968,5.818,8.92l.637-.637L7.877,9.7l3.064-2.97.627.647Z",
    transform: "translate(-1.696 -1.697)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8InstagramVerificationBadge);
export default __webpack_public_path__ + "static/media/icons8-instagram-verification-badge.e50f08cda319a0b51e087774d66350fe.svg";
export { ForwardRef as ReactComponent };